// extracted by mini-css-extract-plugin
export var FirstScreenV2 = "FirstScreenV2-module--FirstScreenV2--gD-UY";